import { BaseModel } from "sjs-base-model";
import ProductInfoModel from './ProductInfoModel';
import ConvenantInfoModel from './ConvenantInfoModel';
import CommissionsDataModel from './CommissionsDataModel';
import AmountsDataModel from './AmountsDataModel';

export default class EstimateModel extends BaseModel {
    public readonly idEstimateRequest: number = 0;
    public readonly idRequestType: number = 0;
    public readonly idEstimate: number = 0;
    public readonly idDossier: number = 0;
    public readonly productInfo: ProductInfoModel = new ProductInfoModel({});
    public readonly convenantInfo: ConvenantInfoModel = new ConvenantInfoModel({});
    public readonly commissionsData: CommissionsDataModel = new CommissionsDataModel({});
    public readonly amountsData: AmountsDataModel = new AmountsDataModel({});

    constructor(data: Partial<EstimateModel>) {
        super();

        this.update(data);
    }
}
